// Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import blackLogo from '../assets/black_logo.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src={blackLogo} alt="Logo" className="h-8 md:h-10" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8 text-acBlack text-lg font-nunitoSans">
            <Link to="/" className="hover:opacity-80 transition">Home</Link>
            <Link to="/about" className="hover:opacity-80 transition">About</Link>
            <Link to="/verification" className="hover:opacity-80 transition">Verification</Link>
            <Link to="/travel" className="hover:opacity-80 transition">Travel</Link>
            <Link to="/contact" className="hover:opacity-80 transition">Contact</Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-acBlack"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isOpen && (
          <div className="absolute top-16 left-0 w-full bg-white shadow-md flex flex-col items-center space-y-6 py-6 md:hidden z-40">
            <Link to="/" className="hover:opacity-80 transition" onClick={() => setIsOpen(false)}>Home</Link>
            <Link to="/about" className="hover:opacity-80 transition" onClick={() => setIsOpen(false)}>About</Link>
            <Link to="/verification" className="hover:opacity-80 transition" onClick={() => setIsOpen(false)}>Verification</Link>
            <Link to="/travel" className="hover:opacity-80 transition" onClick={() => setIsOpen(false)}>Travel</Link>
            <Link to="/contact" className="hover:opacity-80 transition" onClick={() => setIsOpen(false)}>Contact</Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
